import { render, staticRenderFns } from "./DetailsPurchase.vue?vue&type=template&id=16aa0ca1&"
import script from "./DetailsPurchase.vue?vue&type=script&lang=js&"
export * from "./DetailsPurchase.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPurchase.vue?vue&type=style&index=0&id=16aa0ca1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports